import {Modal} from 'react-bootstrap';
import {closeIcon} from 'assets/svg-icons';
import orionLogoLight from './orion-logo-light.png';
import orionLogoDark from './orion-logo-dark.png';
import {ORION_PROMO, getOrionLink} from './config';
import './styles.scss';

interface OrionPopupProps {
  isOpen: boolean;
  theme: string;
  onClose: () => void;
  onTry: () => void;
}

const OrionPopup = ({isOpen, theme, onClose, onTry}: OrionPopupProps) => (
  <Modal
    show={isOpen}
    onHide={onClose}
    centered
    className="orion-popup-root"
    dialogClassName="orion-popup"
    contentClassName={`theme-${theme}`}
    style={{zIndex: 10001}}
  >
    <div className="modal__header p-0">
      <div className="panel__btns" style={{top: '10px', right: '10px', zIndex: 2}}>
        <button className="panel__btn" onClick={onClose} type="button" aria-label="Close">
          {closeIcon}
        </button>
      </div>
    </div>
    <div className={`modal__body orion-popup__body theme-${theme}`}>
      <img src={theme === 'dark' ? orionLogoDark : orionLogoLight} alt="OR:ON" className="orion-popup__logo" />
      <h4 className="orion-popup__headline">{ORION_PROMO.headline}</h4>
      <p className="orion-popup__text">{ORION_PROMO.text}</p>
      <a
        href={getOrionLink('popup')}
        className="orion-popup__btn"
        onClick={event => {
          event.stopPropagation();
          onTry();
        }}
      >
        {ORION_PROMO.cta}
      </a>
    </div>
  </Modal>
);

export default OrionPopup;
